import { createFileRoute } from '@tanstack/react-router';
import { KnowledgeBasePage } from '@/features/knowledge-base/components/KnowledgeBasePage';

export const Route = createFileRoute('/_auth/knowledge-base')({
  component: KnowledgeBasePage,
});
